<!--课程选择-->
<template>
<div>

  <van-popup
      v-model="show"
      closeable
      close-icon="cross"
      position="bottom"
      duration="0.18"
      :close-on-click-overlay="false"
      @close="close"
    >

  <div
    :class="['courseSelect-index', { notShow: productSpecJson && productSpecJson.length === 0 }]"
  >
   <div class="courseTitle">
     <h2>{{currentCourse.cartProductItem.name }}</h2>
     <h3><span>¥</span>{{selectSku.price}}</h3>
   </div>
  <div class="courseWarrp">

    <div class="courseSelect" v-for="(item, n) in productSpecJson" :key="n">
      <h3 class="subheading">{{ item.name }}</h3>
      <div class="courseSelectTabs">
        <p
          v-for="(list, index) in item.options"
          @click="chooseSkuInfo(list.name, n, $event, index, list.isShow)"
          :class="{ tabItem: true, tabSelected: subIndex[n] == index, noneActive: !list.isShow }"
          :key="index"
        >
          <span>{{ list.name }}</span>
          <img v-if="subIndex[n] == index" :src="checkIcon" alt="checkIcon" />
        </p>
      </div>
    </div>
  </div>

  </div>
     <div class="foot">
        <div class="foot-box" @click="deterMineBtn">
        确定
      </div>
    </div>

  </van-popup>
</div>

</template>

<script>
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';
import { reqCourseDetail } from '@/api/courseDetail';
import { reqChangeGood } from '@/api/courseDetail/shoppingCar/shoppingCar';

export default {
  props: {
    currentCourse: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      checkIcon,
      selectedIndex: 0,
      productSpecJson: [], // 展示在页面的sku规格
      iconChecked: checkIcon, // sku选中状态icon
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      selectSku: {}, // 选中的sku信息 最终选择
      someOne: null, // 已选中的sku
      show: true,
    };
  },
  computed: {
  },

  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    this.getCourseInfo();
  },
  mounted() {
    this.checkItem();
  },

  methods: {
    // 获取课程详情信息包含当前可选规格
    async getCourseInfo() {
      const { productId } = this.currentCourse.cartProductItem;
      const res = await reqCourseDetail(productId);
      if (res?.code === 0) {
        this.courseBaseData = res?.data;
        this.modifySkuRespVOList();
      }
    },
    // 修改规格
    async deterMineBtn() {
      const data = {
        cartId: this.currentCourse.cartId,
        productId: this.currentCourse.cartProductItem.productId,
        skuId: this.selectSku.productSkuId,
        type: 1,
      };
      const res = await reqChangeGood(data);
      if (res.code === 0 && res?.data) {
        // this.$toast('修改成功');
        // this.$parent.getCartList();
        this.$emit('reviseType', data);
        this.$emit('singleClose');
      } else {
        this.$toast(res.msg);
        this.$emit('singleClose');
      }
    },
    close() {
      this.$emit('singleClose');
    },
    changeTab(index) {
      this.selectedIndex = index;
    },
    // 选中sku属性
    chooseSkuInfo(item, n, event, index, canClick) {
      if (!canClick) {
        return false;
      }
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        this.selectSku = {};
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      this.checkItem();
      return true;
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      for (let i = 0; i < this.productSpecJson.length; i += 1) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      }
      if (this.productSpecJson) {
        this.productSpecJson.forEach((element, i) => {
          const last = result[i];
          element.options.forEach((k) => {
            result[i] = k.name;
            Object.assign(k, { isShow: self.someOne ? self.isMay(result) : false }); // isShow来判断是否可以选择})
            // k.isShow = this.someOne ? this.isMay(result) : false; // isShow来判断是否可以选择
          });
          result[i] = last; // 还原，目的是记录点下去那个值
        });
      }
      if (this.shopItemInfo[result]) {
        this.selectSku = this.shopItemInfo[result];
      }
      console.log(this.selectSku, 'result');// 最终选择;
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      for (let k = 0; k < result.length; k += 1) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 库存校验
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const { productSkuRespVOList, productSpecJson } = this.courseBaseData;
      if (!productSpecJson && !productSkuRespVOList) return;
      if (!productSpecJson) {
        // 无sku
        // this.$store.dispatch('saveProductSku', productSkuRespVOList[0]);
        return;
      }
      productSkuRespVOList.forEach((item) => {
        this.shopItemInfo[String(JSON.parse(item.specJson).map((child) => child.value))] = item;
      });

      JSON.parse(productSpecJson).forEach((item) => {
        Object.assign(item, { options: item.options.map((element) => ({ name: element })) });
        this.productSpecJson.push(item);
      });
      this.setDefault();
      this.checkItem();
      this.$toast.clear();
    },
    // 勾选用户已选中的SKU
    setDefault() {
      this.someOne = JSON.parse(this.currentCourse.cartProductItem.specJson);
      const defautIdx = [];
      const defautName = [];

      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          this.someOne.forEach((m) => {
            if (list.name === m.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-popup {
  border-radius: 16px 16px 0 0;
  min-height: 40%;
  max-height: 80%;
}
::v-deep .van-popup__close-icon--top-right{
  top:13px;
}
.courseSelect-index {
  box-sizing: border-box;
  width: 100%;
  padding:80px 16px 0 36px;
  background: white;
  .courseTitle{
    padding-bottom: 30px;
    h2{
      width: 678px;
      font-size: 33px;
      font-weight: 500;
      color: #333333;
      line-height: 45px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 22px;

    }
    h3{
    font-size: 36px;
    font-weight: 500;
    color: #FF3938;
      span{
        font-size: 25px;
        padding-right: 8px;
      }
    }
  }

}
.courseWarrp{
  padding-bottom: 145px;
}
.notShow {
  margin: 0 !important;
}
.courseSelect {
  display: flex;
  width: 100%;
  padding-top:5px;
  // margin: 22px 0;
  padding-bottom:20px;
  background: #fff;
  // border-radius: 14px;
  // box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);

  // &:first-child {
  //   padding-top: 26px;
  // }
  // &:last-child {
  //   padding-bottom: 26px;
  // }

  .subheading {
    width: 120px;
    height: 62px;
    // padding-top: 30px;
    color: #333;
    font-weight: bold;
    font-size: 25px;
    line-height: 31px;
  }
  .courseSelectTabs {
    width: 600px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 4px;
    align-self: center;

    p {
      position: relative;
      box-sizing: border-box;
      width: 170px;
      margin-right: 15px;
      padding: 10px;
      color: #787878;
      text-align: center;
      background: #fff;
      border:2px solid #e8e8e8;
      border-radius: 4px;
      font-size: 0;
      margin-bottom: 12px;
      span{
        width: 100%;
        font-size: 22px;
        padding:10px 0;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

      }

      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
        width: 30px;
        height: auto;
      }
    }

    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: block;
      }
    }

    .noneActive {
      color: #cfcfcf;
      background: #f5f5f5;
      border: 2px solid #f5f5f5;
      border-radius: 4px;

      img {
        display: none;
      }
    }
  }
}
::v-deep .van-icon-cross:before{
  color: #666;
}
.foot {
  position: fixed;
  bottom: 0;
  z-index: 200;
  width: 750px;
  padding: 20px 0 40px 0;
  background: #fefffe;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);
  > div {
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 82px;
    text-align: center;
    background: #ff6c02;
    border-radius: 41px;
  }
}
</style>
